const defaultDeviceForm = {
    id: '',
    name: '',
    brand: '',
    description: '',
    page_url: '',
    seguro: null,
    price: '',
    devices: null,
    is_active: true,
    operator: '',
    created_on: '',
    updated_on: ''
}

export default defaultDeviceForm;